module.exports = __webpack_public_path__ + "static/media/c4.b6e687c0.jpg";